import { useIsDemo } from "../api/auth";
import type { RecordingMode, RecordingStatus } from "../api/types";
import { STATUS_META } from "../lib/grade";

// Colored pill for a RecordingStatus, tinted from the status design tokens.
export function StatusBadge({ status }: { status: RecordingStatus }) {
  const meta = STATUS_META[status] ?? { label: status, color: "#7c877f", tone: "neutral" };
  const animate = meta.tone === "active";
  return (
    <span className="status-badge" style={{ ["--sc" as string]: meta.color }}>
      <span className={animate ? "status-dot pulse" : "status-dot"} />
      {meta.label}
    </span>
  );
}

export function ModeBadge({ mode }: { mode: RecordingMode }) {
  // capture mode is an operator detail: not shown to demo sessions
  if (useIsDemo()) return null;
  return <span className="badge mode">{mode}</span>;
}

export default StatusBadge;
